/**
 * Local-first user/role model. Maps 1:1 to a future `teachers` table in
 * Supabase with row-level security keyed off `teacher_id`.
 *
 * TODO(supabase-auth): replace local profiles with Supabase Auth users. Store
 *   the auth user_id on each teacher row.
 * TODO(rls): when migrating, add policies like
 *     CREATE POLICY "teacher reads own rows" ON public.students
 *       FOR SELECT USING ( teacher_id = auth.uid() OR is_admin(auth.uid()) );
 *
 * @typedef {'teacher' | 'admin'} UserRole
 * @typedef {'active' | 'inactive'} UserStatus
 *
 * @typedef {Object} TeacherProfile
 * @property {string} id
 * @property {string} name
 * @property {string} email
 * @property {UserRole} role
 * @property {UserStatus} status   Soft-deletion via status; history preserved.
 * @property {string} createdAt
 * @property {string} [updatedAt]
 */

export const ROLES = { TEACHER: "teacher", ADMIN: "admin" };
export const STATUS = { ACTIVE: "active", INACTIVE: "inactive" };

/** Read-only helper: tolerant of legacy `active: boolean` records. */
export function isActive(t) {
    if (!t) return false;
    if (t.status !== undefined) return t.status === STATUS.ACTIVE;
    return t.active !== false;
}

export function resolveScope(currentUser, workspaceMode) {
    if (!currentUser) return null;
    if (currentUser.role === ROLES.ADMIN) {
        if (!workspaceMode || workspaceMode === "all") return null;
        return workspaceMode;
    }
    return currentUser.id;
}
